import UserService from '../../services/UserService';
import StatusEnum from "../../Enum/Status";

/**
 * Map status number to translation key
 * Status numbers are 1-based, so we subtract 1 to get the index
 */
const getStatusTranslationKey = (statusNumber, isKlant) => {
  const keys = [
    { key: 'received', customerKey: null },                  // 1
    { key: 'readyForDelivery', customerKey: null },                // 2
    { key: 'inRetry', customerKey: null },                         // 3
    { key: 'delivered', customerKey: null },                       // 4
    { key: 'manuallyRemovedFromRetry', customerKey: 'delivered' }, // 5
    { key: 'couldNotBeDelivered', customerKey: null },             // 6
    { key: 'errorDuringProcessing', customerKey: null },           // 7
    { key: 'deliveredToIntermediary', customerKey: null },         // 8
    { key: 'verstuurdDoorRouter', customerKey: null },             // 9
    { key: 'retryRouter', customerKey: 'inRetry' },                // 10
    { key: 'routingGefaald', customerKey: 'errorDuringProcessing' }                   // 11
  ];
  var nrStatus = parseInt(statusNumber);
  if(isNaN(nrStatus)) return statusNumber === "Verwerkt" ? 'delivered' : 'unknown';

  var keyObj = keys[statusNumber - 1];
  if(keyObj === undefined || keyObj === null) return 'unknown';
  else if(keyObj.customerKey !== null && isKlant) return keyObj.customerKey;
  return keyObj.key;
};

/**
 * Check if a message's received date is older than 45 days
 */
const isMessageTooOld = (dateString) => {
  if (!dateString) return false;
  
  const messageDate = new Date(dateString);
  const dateToCompare = new Date();
  // Set the date to 45 days ago
  dateToCompare.setDate(dateToCompare.getDate() - 45);
  
  return messageDate < dateToCompare;
};

/**
 * Check if user has download permissions
 * Employees (Administrator, SD_Medewerker) can always download
 * Customers need Download or Download_compleet role
 */
const hasDownloadPermission = () => {
  if (UserService.hasRole(["Administrator", "SD_Medewerker"])) {
    return true;
  }
  return UserService.hasRole(["Download", "Download_compleet"]);
};

/**
 * Check if user has retry permissions
 * Employees (Administrator, SD_Medewerker) can always retry
 * Customers need Retry role
 */
const hasRetryPermission = () => {
  if (UserService.hasRole(["Administrator", "SD_Medewerker"])) {
    return true;
  }
  return UserService.hasRole(["Retry"]);
};

// const GetMessageStatusString = (status) => {
//     if (status === null || status === undefined) {
//         return null;
//     }

//     // Convert status to number (handle both string and number inputs)
//     const statusNum = typeof status === 'string' ? parseInt(status, 10) : status;
    
//     // Check if valid status (1-based, so index is statusNum - 1)
//     if (statusNum < 1 || statusNum > StatusEnum.length) {
//         return "Onbekend";
//     }

//     // Special case for status 5 when user is employee or admin
//     if (statusNum === 5 && UserService.hasRole(["SD_Medewerker", "Administrator"])) {
//         return "Handmatig verwerkt";
//     }

//     // Get status string from enum (statuses are 1-based, array is 0-based)
//     return StatusEnum[statusNum - 1] ?? "Onbekend";
// };

const GetMessageStatusColor = (status) => {
    let color = null;
    
    // Convert status to string for comparison
    const statusStr = typeof status === 'number' ? status.toString() : status;
    
    switch (statusStr)
    {
        case "1": // ontvangen
        case "2": // in_verwerking
        case "8": // afgeleverd aan tussenpartij
        case "9": // verstuurd door router
            color = "bg-blue-100 text-blue-800";
            break;
        case "3": // in_retry
        case "10": // retry_router
            color = "bg-yellow-100 text-yellow-800";
            break;
        case "4": // afgeleverd
        case "5": // handmatig verwerkt
        case "Verwerkt":
            color = "bg-green-100 text-green-800";
            break;
        case "6": // afleveren gefaald
        case "7": // mapping gefaald
        case "11": // routing gefaald
            color = "bg-red-100 text-red-800";
            break;
    }

    return color ?? "bg-gray-100 text-gray-800";
};

export {
  getStatusTranslationKey,
  isMessageTooOld,
    hasDownloadPermission,
    hasRetryPermission,
    // GetMessageStatusString,
    GetMessageStatusColor
};